'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TitleBox = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(TitleBox, _Component);

  function TitleBox() {
    (0, _classCallCheck3.default)(this, TitleBox);
    return (0, _possibleConstructorReturn3.default)(this, (TitleBox.__proto__ || (0, _getPrototypeOf2.default)(TitleBox)).apply(this, arguments));
  }

  (0, _createClass3.default)(TitleBox, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          autoFocus = _props.autoFocus,
          errors = _props.errors,
          onChange = _props.onChange,
          onKeyUp = _props.onKeyUp,
          polyglot = _props.polyglot,
          title = _props.title;


      return _react2.default.createElement(_reactBootstrap.FormControl, {
        id: 'event-title-box',
        className: 'form-control input-h1' + (errors.length > 0 ? ' has-error' : ''),
        onChange: onChange,
        onKeyUp: onKeyUp,
        value: title,
        autoFocus: autoFocus,
        placeholder: polyglot.t('events.titleBox.help')
      });
    }
  }]);
  return TitleBox;
}(_react.Component), _class.propTypes = {
  autoFocus: _propTypes2.default.bool,
  errors: _propTypes2.default.array.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  onKeyUp: _propTypes2.default.func.isRequired,
  title: _propTypes2.default.string,
  polyglot: _propTypes2.default.object.isRequired
}, _class.defaultProps = {
  autoFocus: false
}, _temp);
exports.default = TitleBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/TitleBox.js
// module id = 2224
// module chunks = 0